import React, { useEffect, useState } from 'react';
import './ConnectionOptions.scss';
import DiscoverHeader from '../../../components/DiscoverHeader/DiscoverHeader';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  useMediaQuery,
  useTheme
} from '@mui/material';
import DirectIntegrationTab from '../../../components/DirectIntegrationTab/DirectIntegrationTab';
import TechnologyPartnersTab from '../../../components/TechnologyPartnersTab/TechnologyPartnersTab';
import DesktopPlatformTab from '../../../components/DesktopPlatformTab/DesktopPlatformTab';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from 'react-i18next';
// import ConnectionFooterBanner from "../../../components/connectionBanner/connectionBanner";

const ConnectionOptions = ({ ...props }) => {
  const urls = ['direct-integration', 'technology-partners', 'ac-connex'];
  const { t, i18n } = useTranslation();
  const json = t('ndc-program.connection-options', { returnObjects: true });
  const [activeTabIndex, setActiveTabIndex] = useState<number>(props.showTab);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = (index: number) => {
    setActiveTabIndex(index);
    setAnchorEl(null);
    window.history.replaceState(
      null,
      urls[index],
      `/${i18n.language}/ndc-program/connection-options/${urls[index]}`
    );
    // history(`/ndc-program/connection-options/${urls[index]}`);
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const tabsLabel = json['tabsLabel'];
  const breadcrumb = json['breadcrumb'];
  const ariaLabelMap = json['ariaLabelMap'];

  return (
    <>
      {json && (
        <main className="connection-options-container">
          <DiscoverHeader
            title={json['title']}
            paragraph={json['connection-options-header']}
            breadcrumb={breadcrumb}
            image="planeConnecImg.png"
            dropdown={true}
          />
          {isDesktop ? (
            <Box
              //role="main"
              aria-label={ariaLabelMap}
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                marginX: '96px',
                marginTop: '10px'
              }}
            >
              {/* <nav aria-label="connection-options-tabs"> */}
                <Tabs
                  value={activeTabIndex}
                  aria-label="Connection Options Tabs"
                  className="connectionTabs"
                >
                  {tabsLabel.map((label, index) => (
                    <Tab
                      key={`${label}-${index}`}
                      aria-controls={`tabpanel-${index}`}
                      value={index}
                      label={label}
                      onClick={() => handleMenuItemClick(index)}
                    />
                  ))}
                </Tabs>
              {/* </nav> */}
            </Box>
          ) : (
            <Box className="selectDropdown">
              <List
                component="nav"
                aria-label={ariaLabelMap}
                sx={{ bgcolor: 'background.paper', margin: '0 auto' }}
              >
                <ListItem
                  id="lock-button"
                  aria-haspopup="listbox"
                  aria-controls="lock-menu"
                  aria-label={tabsLabel[activeTabIndex]}
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClickListItem}
                >
                  <ListItemText primary={tabsLabel[activeTabIndex]} />
                  <KeyboardArrowDownIcon />
                </ListItem>
              </List>
              <Menu
                id="lock-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'lock-button',
                  role: 'listbox'
                }}
              >
                {tabsLabel.map((option: string, index: number) => (
                  <MenuItem
                    key={option}
                    disabled={index === activeTabIndex}
                    selected={index === activeTabIndex}
                    onClick={() => handleMenuItemClick(index)}
                    role="button"
                    aria-label={`${tabsLabel[activeTabIndex]}-item`}
                  >
                    {option}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          )}
          {
            [
              <DirectIntegrationTab jsonData={json} />,
              <TechnologyPartnersTab jsonData={json} />,
              <DesktopPlatformTab jsonData={json} />
            ][activeTabIndex]
          }
          {/* <ConnectionFooterBanner data={props.data} /> */}
        </main>
      )}
    </>
  );
};

export default ConnectionOptions;
